/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'
import {
	PanelBody, RangeControl, SelectControl 
} from '@wordpress/components'
import {
	RichText
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import {
	URLInputControl, BackgroundSettings,
} from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.market-button.edit.inspector.style.before', 'czgb/market-button', ( output, props ) => {
	const { 
		attributes, 
		setAttributes,  
	} = props

	const {
		limit,
	} = props.attributes

	return (
		<Fragment>
			<PanelBody title={ __( 'General', i18n ) }>
				<RangeControl
					label={ __( 'Number of Buttons', i18n ) }
					value={ limit !== undefined ? limit : 3 }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.market-button.limit.edit.inspector.max.limit', 4 ) }
				/>
			</PanelBody>
			{ range( 1, limit + 1 ).map( i => {
				const bgColor = attributes[ `bgcolor${ i }` ]
				const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
				const icon = attributes[ `icon${ i }` ] !== undefined ? attributes[ `icon${ i }` ] : i === 1 ? 'btn-apple' : 'btn-google'
				const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

				return (
					<Fragment key={ i }>
						<PanelBody title={ __( `Button #${ i } Settings`, i18n ) } initialOpen={ false }>
							<SelectControl
								label={ __( 'Icon' ) }
								values={ icon }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('Apple', 'cartzilla', i18n ), value: 'btn-apple' },
									{ label: __('Google', 'cartzilla', i18n ), value: 'btn-google' },
									{ label: __('Windows', 'cartzilla', i18n ), value: 'btn-windows' },
									{ label: __('Amazon', 'cartzilla', i18n ), value: 'btn-amazon' },
								] }
								onChange={ icon => setAttributes( {  [ `icon${ i }` ] : icon } ) }
							/>
							<BackgroundSettings
								background={ bgColor !== undefined ? bgColor : 'bg-primary' }
								backgroundColor={ bgcustomColor }
								onChangeBackground={ bgColor => setAttributes( { [ `bgcolor${ i }` ]: bgColor, [ `bgcustomcolor${ i }` ]: '' } ) }
								onChangeBackgroundColor={ bgcustomColor => setAttributes( { [ `bgcustomcolor${ i }` ]: bgcustomColor.hex, [ `bgcolor${ i }` ]: '' } ) }
								onRemoveBackground={ () => { setAttributes( { [ `bgcolor${ i }` ]: '', [ `bgcustomcolor${ i }` ]: '' } ) } }
							/>
							<URLInputControl
								value={ link }
								onChange={ link => setAttributes( { [ `link${ i }` ]: link } ) }
							/>
						</PanelBody>
					</Fragment>
				)
			} ) }
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className
	} = props 

	const {
		limit,
	} = attributes

	const mainClasses = classnames( [
		className,
		'czgb-market-button',
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, ( limit ) + 1 ).map( i => {

		const PreTitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
		const icon = attributes[ `icon${ i }` ]
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

		let defaulttitle = ''
		let defaultpretitle = ''
		let defaultIcon = ''

		if ( (i % 4 ) === 1 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "App Store"
			defaultIcon = 'btn-apple'
		}

		if ( (i % 4 ) === 2 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "Google Play"
			defaultIcon = 'btn-google'
		}

		if ( (i % 4 ) === 3 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "Windows Store"
			defaultIcon = 'btn-windows'
		}

		if ( (i % 4 ) === 0 ) { 
			defaultpretitle = "Download on the"
			defaulttitle = "Amazon.com"
			defaultIcon = 'btn-amazon'
		}

		const bgstyle = { backgroundColor: bgcustomColor && bgcustomColor }

		const iconClass = classnames( [
			icon === 'none' && '',
			icon === 'btn-apple' && ' btn-apple',
			icon === 'btn-google' && ' btn-google',
			icon === 'btn-windows' && ' btn-windows',
			icon === 'btn-amazon' && ' btn-amazon'
		] )

		const pretitleComp =(
			<RichText
				tagName="span"
				className="btn-market-subtitle"
				value={ PreTitle || defaultpretitle }
				onChange={ PreTitle => setAttributes( { [ `pretitle${ i }` ]: PreTitle } ) }
				placeholder={ __( 'PreTitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const titleComp =(
			<RichText
				tagName="span"
				className="btn-market-title"
				value={ Title || defaulttitle }
				onChange={ Title => setAttributes( { [ `title${ i }` ]: Title } ) }
				placeholder={ __( 'Title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const output = (
			<Fragment>
				<button className={ `btn-market ${ iconClass || defaultIcon } mr-3 mb-3 ${ bgColor ? bgColor : bgcustomColor ? '' : '' }` } style={ bgstyle } href={ link } role="button">
					{ pretitleComp }
					{ titleComp }
				</button>
			</Fragment>
		)
			
			return output
	}   )

	return (
		<div className={ mainClasses }>
			{ content }
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
